// extracted by mini-css-extract-plugin
export var list = "BrragYoT";
export var time = "JDXhS28v";
export var event = "FaAtdjbb";
export var eventCard = "Fcd9Nqos";
export var eventBar = "jDxDCS+N";
export var eventContent = "AUJGTDG+";
export var eventTime = "Urd035SP";
export var eventDetailsMeta = "_9zhry-1-";
export var eventDetailsHead = "AVnQTI2u";